import { Component, ElementRef, OnInit, Input, Output, EventEmitter, ContentChildren, QueryList } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { ListModel } from '../../models/list/list.model';
import { ListStylingModel } from '../../models/list/list-styling.model';
import { CfItemComponent } from '../item/item.component';
import { ListTemplates } from '../../templates/list.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>List component based on Angular Material List</p>
 * <p>Example of using:</p>
 * <pre>
 * <code><</code>cf-wizard [properties]="myList" [styling]="myListStyles"<code>></code><code><</code><code>/</code>cf-list<code>></code>
 * </pre>
 */
export class CfListComponent extends CfCoreComponent implements OnInit {
/**
 * It is an attribute <b>[properties]</b> of directive <b>cf-list</b> which take ListModel object.
 * <p>Example of model:</p>
 * <code><pre>{{'{'}}
 *  title: 'This is list title',
 *  selectable: true,
 *  withCheckbox: true
 * {{'}'}}</pre></code>
 * <h4>title: string</h4>
 * It is title for List component
 * <h4>selectable: boolean</h4>
 * If List is selectable. If yes - output <b>onSelect</b> is available to use.
 * List items will inherit that property if they didn't have their own.
 * <h4>withCheckbox: boolean</h4>
 * If List items will have checkboxes.
 * List items will inherit that property if they didn't have their own.
 */
public properties: ListModel;
/**
 * It is an attribute <b>[styling]</b> of directive <b>cf-list</b> which take ListStylingModel object with next properties:
 * <h4>container: StylingModel</h4>
 * Styling properties for component container
 * <h4>title: StylingModel</h4>
 * Styling properties for component title
 */
public styling: ListStylingModel;
/**
 * Input property for the title
 * @param {?} value
 * @return {?}
 */
set title(value: string) { this.properties.title = value; }
/**
 * Input property for selectable
 * @param {?} value
 * @return {?}
 */
set selectable(value: boolean) { this.properties.selectable = value; }
/**
 * Input property to show checkbox on list items
 * @param {?} value
 * @return {?}
 */
set withCheckbox(value: boolean) { this.properties.withCheckbox = value; }
/**
 * @hidden 
 * Array for selected items IDs
 */
selectedItems: number[] = [];
/**
 * It is <b>(onSelect)</b> attribute of <b>cf-list</b> component. Is emmiting event with array of selected items IDs
 */
onSelect = new EventEmitter();
/**
 * @hidden 
 * Private property for generating IDs for list items when list is selectable
 */
randomId = 0;
/**
 * @hidden 
 * Array with list items
 */
items: QueryList<CfItemComponent>; Î
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /** @hidden */ templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new ListModel();
    this.styling = new ListStylingModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit(): void {
    this.getMyTemplate('list', ListTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'LIST').then( sampler => {
        // console.log('LIST', this);
      });
    });
  }
/**
 * @hidden 
 * After List content was initialized and component is selectable,
 * will be generated IDs for all list items and each selected item ID will be pushed to selectedItems array.
 * @return {?}
 */
ngAfterContentInit() {
    if (this.properties != null && this.items != null && this.items.length > 0) {
      if (this.properties.selectable !== false) {
        for (let /** @type {?} */ item of this.items.toArray()) {
          item.internalId = this.randomId;
          this.randomId++;
          if (item.properties.selected === true) {
            this.selectedItems.push(item.internalId);
          }
          setTimeout(
            _ => {
              if (!item.properties.hasOwnProperty('selectable')) { item.properties.selectable = this.properties.selectable; }
              if (!item.properties.hasOwnProperty('withCheckbox')) { item.properties.withCheckbox = this.properties.withCheckbox; }
              item.itemClicked.subscribe(data => this.updateValues(data));
            }
          );
        }
      }
    }
  }
/**
 * @hidden 
 * Function to update selectedItems array values and emit them
 * @param {?} data  item data object
 * @return {?}
 */
updateValues(data) {
    if (data['value'] === true) {
      this.selectedItems.push(data['id']);
      this.selectedItems.sort();
      this.onSelect.emit(this.selectedItems);
    } else {
      this.selectedItems.splice(this.selectedItems.indexOf(data['id']), 1);
      this.onSelect.emit(this.selectedItems);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-list',
  template: "<div *ngIf=\"_inited && properties?.display\" class=\"{{activeTemplate.style?.container?.class}} {{styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-list-container'\"> <md-nav-list> <h3 *ngIf=\"properties?.title\" class=\"{{activeTemplate.style?.title?.class}} {{styling?.title?.class}} {{getDynamicClasses(activeTemplate.style?.title?.dynamicClass)}} {{getDynamicClasses(styling?.title?.dynamicClass)}}\" [ngClass]=\"'cf-list-title'\" md-subheader>{{properties?.title}}</h3> <ng-content #myContent></ng-content> </md-nav-list> </div>",
  styles: [":host md-nav-list { width: 100%; } :host md-nav-list md-list-item { position: relative; z-index: 0; } :host md-nav-list .cf-list-item-action { width: 100%; display: flex; flex-direction: row; align-items: top; font-family: 'Avenir', \"Helvetica Neue\", sans-serif; box-sizing: border-box; font-size: 16px; padding: 8px 0; } :host md-nav-list .cf-list-item-trigger { transition: all .5s; position: absolute; z-index: 100; bottom: 0px; right: 0px; } :host md-nav-list .cf-list-item-trigger.cf-expanded { transform: rotate(-90deg); } :host md-nav-list .cf-list-item-details-container { width: 100%; font-family: 'Avenir', \"Helvetica Neue\", sans-serif; } :host md-nav-list cf-list-item-details-template { display: none; transition: all .5s; } :host md-nav-list cf-list-item-details-template.cf-expanded { display: block; } :host ::ng-deep .mat-list-item-content { height: auto !important; flex-direction: column !important; } :host [hidden] { display: none !important; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'title': [{ type: Input, args: ['title', ] },],
'selectable': [{ type: Input, args: ['selectable', ] },],
'withCheckbox': [{ type: Input, args: ['withCheckbox', ] },],
'onSelect': [{ type: Output },],
'items': [{ type: ContentChildren, args: [CfItemComponent, ] },],
};
}

function CfListComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfListComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfListComponent.ctorParameters;
/** @type {?} */
CfListComponent.propDecorators;
/**
 * It is an attribute <b>[properties]</b> of directive <b>cf-list</b> which take ListModel object.
 * <p>Example of model:</p>
 * <code><pre>{{'{'}}
 *  title: 'This is list title',
 *  selectable: true,
 *  withCheckbox: true
 * {{'}'}}</pre></code>
 * <h4>title: string</h4>
 * It is title for List component
 * <h4>selectable: boolean</h4>
 * If List is selectable. If yes - output <b>onSelect</b> is available to use.
 * List items will inherit that property if they didn't have their own.
 * <h4>withCheckbox: boolean</h4>
 * If List items will have checkboxes.
 * List items will inherit that property if they didn't have their own.
 * @type {?}
 */
CfListComponent.prototype.properties;
/**
 * It is an attribute <b>[styling]</b> of directive <b>cf-list</b> which take ListStylingModel object with next properties:
 * <h4>container: StylingModel</h4>
 * Styling properties for component container
 * <h4>title: StylingModel</h4>
 * Styling properties for component title
 * @type {?}
 */
CfListComponent.prototype.styling;
/**
 * @hidden 
 * Array for selected items IDs
 * @type {?}
 */
CfListComponent.prototype.selectedItems;
/**
 * It is <b>(onSelect)</b> attribute of <b>cf-list</b> component. Is emmiting event with array of selected items IDs
 * @type {?}
 */
CfListComponent.prototype.onSelect;
/**
 * @hidden 
 * Private property for generating IDs for list items when list is selectable
 * @type {?}
 */
CfListComponent.prototype.randomId;
/**
 * @hidden 
 * Array with list items
 * @type {?}
 */
CfListComponent.prototype.items;
/** @type {?} */
CfListComponent.prototype.Î;
/**
 * @hidden
 * @type {?}
 */
CfListComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
